import styled from 'styled-components'

import { _M_Medium } from '../../styles/typography'

export const NPSRating = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  ${_M_Medium};
`
